<template>
  <div class="authWrapper new-login-wrapper">
    <div class="container">
      <div class="row login-white-wrap whiteBG-wrap login-margin">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <transition :name="transitionName" mode="out-in">
              <component 
                :is="currentComponent" 
                :key="$route.path"
              />
            </transition>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding p-0">
          <LoginCarsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginCarsoule from "./Logincarsoule.vue";
import NewLoginEmail from "./NewLoginEmail.vue";
import NewLoginPassword from "./NewLoginPassword.vue";

export default {
  name: "Login",
  components: {
    LoginCarsoule,
    NewLoginEmail,
    NewLoginPassword,
  },
  computed: {
    currentComponent() {
      return this.$route.path == "/" || this.$route.path=='/login' 
        ? "NewLoginEmail"
        : "NewLoginPassword";
    },
    transitionName() {
      return this.$route.path === "/" || this.$route.path=='/login' ? "slide-right-fade" : "slide-left-fade";
    }
  },
};
</script>

<style>
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}
.rep-icon-login img {
  width: 100%;
}

.login-signup-btn-wrap{
  font-size: 14px;
  margin-top: 0.8rem;
}
.login-signup-btn-wrap a{
  color: #00ccff;
}
/* .login-margin{
    margin-top: 0rem !important;
  } */


   @media (min-width: 768px) {
    .authWrapper .login-white-wrap  > div{
      display: flex;
      align-items: center;
    }
  }
</style>